SNI.Application.addModule('looking-for-something', function(context) {

  return {
    behaviors: ['invoke-tiles']
  };
});